import React, { useState, useEffect,useRef  } from "react";
import styles from "./ProfileInfo.module.css";
import { getInsta } from "../../../actions/AuthActions";
import { useDispatch } from "react-redux";
import Banner from "../../../assets/images/banner.png";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { uploadImage } from "../../../actions/UploadAction";
import { useParams } from "react-router-dom";
import guide from "../../../assets/guide.gif";
import UserComponent from "./ProfileComponent/UserComponent";
import LocationComponent from "./ProfileComponent/LocationComponent";
import ContactComponent from "./ProfileComponent/ContactComponent";
import PreferenceComponent from "./ProfileComponent/PreferenceComponent";
import ProfileDetail from "./ProfileDetail";

const componentMap = {
  UserComponent,
  //CallComponent,
  LocationComponent,
  ContactComponent,
  PreferenceComponent,
  // BusinessDetails,
};

const ProfileInfo = ({ profileData, isBrand, handleUserUpdate,handleYoutubeConnect }) => {
  // console.log("profileData", profileData);
  const param = useParams();

  const [selectedComponent, setSelectedComponent] = useState("UserComponent");
  const SelectedComponent = selectedComponent
    ? componentMap[selectedComponent]
    : null;
  //console.log(isBrand)
  // console.log("profileData", profileData);
  const [run, setRun] = useState(false);
  //const date = new Date(profileData.createdAt);
  const [facebookUserAccessToken, setFacebookUserAccessToken] = useState("");
  const [instaid, setInstaId] = useState(null);
  const [connecting, setConnecting] = useState(false);
  // const [connected, SetConnected] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [unComplete, setUnComplete] = useState(false);
  const [uploadPopup, setUploadpopup] = useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  //const navigate = useNavigate();
  const dispatch = useDispatch();
  // console.log("data", profileData)

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    if (!profileData.instaId) {
      setUnComplete(true);
    }
  }, []);
   

  const handleTabClick = () => {
    handleConnectInstagram()
  };

    /* --------------------------------------------------------
   *              FACEBOOK LOGIN AND INITIAL SETUP
   * --------------------------------------------------------
   */

  // Check if access token is in localStorage when the component mounts
  useEffect(() => {
    const storedAccessToken = localStorage.getItem("FacebookUserAccessToken");
    const storedInstaId = localStorage.getItem("InstaId");

    if (storedAccessToken) {
      setFacebookUserAccessToken(storedAccessToken);
    } else {
      window.FB.getLoginStatus((response) => {
        if (response.status === "connected") {
          const accessToken = response.authResponse?.accessToken;
          setFacebookUserAccessToken(accessToken);
          //toast.success("Connected to Instagram");
          // setShowPopup(false);
        }
      });
    }

    if (storedInstaId) {
      setInstaId(storedInstaId);
    }

    // Trigger the chain of function calls if the user is already logged in
  }, [facebookUserAccessToken]);

  const logInToFB = async () => {
    window.FB.login(
      (response) => {
        const accessToken = response.authResponse?.accessToken;
        //const grantedScopes = response.authResponse?.grantedScopes;

        // console.log("grantedScopes", grantedScopes);
        //  console.log("accessToken", accessToken);
        if (accessToken) {
          //setFacebookUserAccessToken(accessToken);
          localStorage.setItem("FacebookUserAccessToken", accessToken);
        }
        passToken(accessToken);
      },
      {
        scope:
          "pages_show_list,business_management,instagram_basic,instagram_manage_insights", // Add desired permissions here
      }
    );
  };

  const passToken = async (token) => {
    const userId = profileData._id;
    console.log("Token", token);

    try {
      const data = dispatch(getInsta({ token, userId }));
      data
        .then((result) => {
          setShowPopup(false);
          ///  toast.success("Connected to Instagram");
          // console.log(result);
          setConnecting(false);
        })
        .catch((error) => {
          console.error("Error extracting data:", error);
        });
    } catch (error) {
      console.error("Request failed:", error);
    }
  };

  const showPopupDiv = () => {
    setShowPopup(true);
  };

  const handleConnect = () => {
    setRun(true);
    setConnecting(true);
    logInToFB();
  };


  const handleConnectInstagram = () => {
    handleConnect();
  }
  // const handleOpenInstagram = () => {
  //   const url = `https://instagram.com/${profileData.instaUsername}`;
  //   window.open(url, "_blank");
  // };

  const handleSetProfile = () => {
    setShowPopup(true);
    setUnComplete(false);
  };

  const handleImagePopup = (e) => {
    e.preventDefault();
    setUploadpopup(!uploadPopup);
  };

  const memberSince = () => {
    const date = new Date(profileData.createdAt);
    const month = date.toLocaleString("default", { month: "long" }); // Returns full month name (e.g., 'September')
    const year = date.getFullYear(); // Returns year (e.g., 2024)

    // Concatenate month and year
    const monthYear = `${month} ${year}`;
    return monthYear;
  };

  const closePopup = () => {
    setUploadpopup(!uploadPopup);
  };

  const updateProfileImage = async () => {
    const influencerId = param.id;
    console.log("Selected Image URL: ", selectedImage);

    if (!selectedImage) {
      console.error("No image selected");
      return;
    }
    setUploadpopup(!uploadPopup);

    const filedata = new FormData();
    const fileName = Date.now() + selectedImage.name;
    filedata.append("name", fileName);
    filedata.append("file", selectedImage);
    try {
      await dispatch(uploadImage(influencerId, filedata));
    } catch (err) {
      console.log(err);
    }
  };

  const handleImageUpload = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (file) {
      setSelectedImage(file);
      //console.log(selectedImage)
      setPreview(URL.createObjectURL(file));
    }
  };


  
  return (
    <>


   
      {uploadPopup && (
        <>
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-50"
            onClick={closePopup}
          ></div>

          {/* Popup Container */}
          <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-lg shadow-lg w-80 text-center z-50">
            {/* Image Upload Input */}
            <div>
              <label
                htmlFor="imageUpload"
                className="block text-lg font-semibold mb-2"
              >
                Upload Image:
              </label>
              <input
                type="file"
                id="imageUpload"
                accept="image/*"
                className=" p-2 border border-gray-300 rounded w-full"
                onChange={handleImageUpload}
              />

              {/* Image Preview (Optional) */}
              {selectedImage && (
                <div className="mt-4">
                  <img
                    src={preview}
                    alt="Preview"
                    className="w-36 h-auto rounded-full mx-auto"
                  />
                </div>
              )}

              {/* Buttons */}
              <div className="mt-4 flex justify-center space-x-2">
                <button
                  className="bg-pink-600 hover:bg-pink-700 text-white font-semibold py-2 px-4 rounded-lg"
                  onClick={updateProfileImage}
                >
                  Update Profile Image
                </button>
                <button
                  className="bg-gray-500 hover:bg-gray-600 text-white font-semibold py-2 px-4 rounded-lg"
                  onClick={closePopup}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <div className={styles.banner}>
        <img
          src={Banner}
          alt="Banner Background"
          className={styles.bannerImage}
        />
        <div className={styles.profileSection}>
          {isBrand ? (
            <img
              src={profileData?.profile_image}
              alt="Profile"
              className={styles.profileImage}
            />
          ) : (
            <>
              <img
                src={profileData?.profile_image}
                alt="Profile"
                className={styles.profileImage}
                onClick={handleImagePopup}
              />
            </>
          )}

          <div className={styles.profileDetails}>
            <div
              className="relative flex flex-row gap-2"
              style={{ fontFamily: "Gilroy-Medium" }}
            >
              <span className="text-[22px] font-bold">
                {" "}
                Hi, I'm {profileData.displayname}{" "}
              </span>
              {profileData?.isVerified && (
                <span className="flex items-center ">
                  <RiVerifiedBadgeFill className="absolute w-5 h-5 text-[#ff007f] rounded-full " />
                </span>
              )}
            </div>
            <p>Life's too short for boring Marketing!</p>

            <div className={styles.ratingLocation}>
              <div
                className={styles.rating}
                style={{
                  color: "white",
                  backgroundColor: "rgba(43, 43, 43, 0.36)",
                  padding: "0.2rem 0.5rem",
                  borderRadius: "5px",
                }}
              >
                <span>⭐⭐⭐⭐⭐ Reviews</span>
                <br />
                <span>Coming soon</span>
              </div>
            </div>
            <div className={styles.contactViews}>
              <button className={styles.contactButton}>Contact</button>
              <div className={styles.views}>{profileData.ER}% ER</div>
            </div>
          </div>
        </div>
        <div className={styles.extraDetails}>
          <span>Member since: {memberSince()}</span>
          <span>Last Active: about 2 hours</span>
          <span>Responds in 4 Hrs</span>
        </div>
      </div>

      <ProfileDetail isBrand={isBrand} profileData={profileData} handleConnect={handleConnect} />

      <div className=" rounded-lg w-full text-black">
        <div className="">
          {showPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-lg shadow-lg w-11/12 max-w-lg">
                <button
                  className="relative top-2 right-2 text-xl"
                  onClick={handleClosePopup}
                >
                  &times;
                </button>
                <h3 className="font-bold text-lg">Instagram Connection</h3>
                <h4 className="text-md font-semibold">
                  Condition for connecting Instagram to Inggage
                </h4>
                <ul className="list-disc text-sm">
                  <li>
                    Your Instagram account should be linked to your valid
                    Facebook page.
                  </li>
                  <li>Allow all permissions in edit access.</li>
                </ul>
                <div>
                  <img src={guide} style={{ width: "450px" }}></img>
                </div>
                {connecting ? (
                  <button className="btn btn-primary mt-4">
                    Connecting...
                  </button>
                ) : (
                  <button
                    className="px-3 py-2 text-white bg-pink-600 rounded-full mt-4"
                    onClick={handleConnect}
                  >
                    Connect Instagram
                  </button>
                )}
              </div>
            </div>
          )}

          {unComplete && !isBrand && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
              <div className="bg-white p-4 rounded-lg shadow-lg w-11/12 max-w-md">
                <h2 className="text-2xl font-bold mb-2">
                  Just one last step...!
                </h2>
                <p className="text-lg">
                  Please complete your profile by connecting Instagram to
                  proceed. It will help you to make fast collaborations.
                </p>
                <button
                  className="mt-4 px-4 py-2 bg-pink-600 text-white rounded-full"
                  onClick={handleSetProfile}
                >
                  Proceed
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileInfo;
